var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopSpeech({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2009 0C24.9315 0 24.6575 0.0725442 24.4064 0.240302L8.21918 10.7456H0.730594C0.328767 10.7456 0 11.072 0 11.471V24.529C0 24.928 0.328767 25.2544 0.730594 25.2544H8.21918L24.4064 35.7597C24.6575 35.9229 24.9361 36 25.2009 36C25.9635 36 26.6667 35.397 26.6667 34.5446V1.45542C26.6667 0.603023 25.9635 0 25.2009 0Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSpeech);
export default __webpack_public_path__ + "static/media/stop_speech.2cec6b0bfa3e67c9b2de907390534f0f.svg";
export { ForwardRef as ReactComponent };